import { Box } from '@mui/material';
import { CalendarDateService } from '@uplift/services';
import { useMemo } from 'react';
import { DashboardTitle } from '../../components/dashboard-title.component';
import { Button, Money, StackableCard, StackableCardDeck } from '@uplift/ui-v2';
import { ArrowForward } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { ROUTING_CONFIG } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { useCurrentuser } from '@uplift/contexts';
import { useFinancePaymentDashboardQuery } from '@uplift/queries';
import { PeriodSummaryCardMSO } from './PeriodSummaryCardMSO.component';


export const PaymentsMSO: React.FC = () => {
  const l10n = useL10n();
  const me = useCurrentuser();
  const currentDate = CalendarDateService.date();

  const thisMonth = useMemo(
    () => currentDate
      .set('date', 20)
      .utc()
      .startOf('day')
      .format(),
    [ currentDate ]
  );
  const lastMonth = useMemo(
    () => currentDate
      .subtract(1, 'month')
      .set('date', 20)
      .utc()
      .startOf('day')
      .format(),
    [ currentDate ]
  );

  const { data: thisMonthData } = useFinancePaymentDashboardQuery(me.id, thisMonth);
  const { data: lastMonthData } = useFinancePaymentDashboardQuery(me.id, lastMonth);

  return (
    <div>
      <Box mb={3} display="flex" justifyContent="space-between" alignItems="center">
        <DashboardTitle text={l10n.payments.finance} />

        <Button color="secondary" endIcon={<ArrowForward />} component={Link} to={ROUTING_CONFIG.finance}>
          {l10n.payments.details}
        </Button>
      </Box>
      <StackableCardDeck direction="vertical">
        <StackableCard>
          <PeriodSummaryCardMSO
            disabled={thisMonthData?.data.paid === 0}
            value={thisMonthData?.data.paid === undefined ? undefined : <Money value={thisMonthData?.data.paid} />}
            subtitle={l10n.sessions.submittedBillings(CalendarDateService.date(thisMonthData?.data.last.started)?.format('MMMM'))}
          />
        </StackableCard>
        <StackableCard>
          <PeriodSummaryCardMSO
            disabled={lastMonthData?.data.paid === 0}
            value={lastMonthData?.data.paid === undefined ? undefined : <Money value={lastMonthData?.data.paid} />}
            subtitle={l10n.sessions.submittedBillings(CalendarDateService.date(lastMonthData?.data.last.started)?.format('MMMM'))}
          />
        </StackableCard>
      </StackableCardDeck>
    </div>
  );
};
